var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-page report"},[(!_vm.isLoading)?[_c('AppPageHeader',{attrs:{"page-title":"Мониторинг"}}),_c('div',{staticClass:"app-page__content"},[_c('div',{staticClass:"app-layout report__layout"},[_c('div',{staticClass:"app-page__block"},[_c('DeviceStatsTable')],1)])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }